import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "nav-icon-fixed" }
const _hoisted_2 = { class: "container-fluid px-0" }
const _hoisted_3 = {
  id: "navigation-icon",
  class: "row m-0 pt-1 justify-content-between icon-size-nav"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bars" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-x" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"col\"><div class=\"row social-icons justify-content-end text-end\"><div class=\"col\"><a class=\"px-3\" href=\"https://www.strava.com/clubs/980836\" target=\"_blank\"><i class=\"fa-brands fa-strava\"></i></a><a class=\"px-3\" href=\"https://www.instagram.com/klatrekongen/\" target=\"_blank\"><i class=\"fa-brands fa-instagram\"></i></a></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.showNav)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "col-1 ms-1",
              onClick: _cache[0] || (_cache[0] = ($event: any) => {
                        _ctx.$emit('showNav');
                    })
            }, _hoisted_5))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "col-1 ms-1",
              onClick: _cache[1] || (_cache[1] = ($event: any) => {
                        _ctx.$emit('showNav'); 
                    })
            }, _hoisted_7)),
        _hoisted_8
      ])
    ])
  ]))
}